/* eslint-disable */
import type {
  TGetNewbuildingBrokerModalsMicroFrontendModel,
  IMappers,
  TGetNewbuildingBrokerModalsMicroFrontendResponse,
  IV1GetNewbuildingBrokerModalsMicroFrontendResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createGetNewbuildingBrokerModalsMicroFrontendModel(): TGetNewbuildingBrokerModalsMicroFrontendModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'newbuilding-broker-modals-micro-frontend',
    pathApi: '/v1/get-newbuilding-broker-modals-micro-frontend/',
    response: {
      200: {
        contentType: 'json',
      },
    },
  };
}

export interface IGetNewbuildingBrokerModalsMicroFrontendOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
}

export async function fetchGetNewbuildingBrokerModalsMicroFrontend<TResponse200>({
  httpApi,
  config,
  mappers,
}: IGetNewbuildingBrokerModalsMicroFrontendOptions<TResponse200>): Promise<
  FetchResponse<TGetNewbuildingBrokerModalsMicroFrontendResponse> | TResponse200
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetNewbuildingBrokerModalsMicroFrontendModel(),
    config,
  )) as FetchResponse<TGetNewbuildingBrokerModalsMicroFrontendResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV1GetNewbuildingBrokerModalsMicroFrontendResponse, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetNewbuildingBrokerModalsMicroFrontendResponse>;
}
